export default __webpack_public_path__ + "static/media/WhoEatsWhat_05.0d9965bd.png";